import { PublicType } from '@Shared.Angular/@types/core/contracts/constants/publicType';
import IProcedureOverview from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureOverview';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';

angular
  .module('flowingly.runner.library')
  .controller(
    'procedureSharingDialogController',
    procedureSharingDialogController
  );

procedureSharingDialogController.$inject = ['$scope'];

function procedureSharingDialogController($scope: IScopeNgDialog) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const ctrl = this as {
    procedureName: string;
    initialPublicType: PublicType | null;
    publicType: PublicType | null;
    publicShareableUrl: string;
    iframeTag: string;
    save: () => void;
    cancel: () => void;
    onPublicTypeChange: (value: PublicType | null) => void;
  };
  const procedure = $scope.ngDialogData.procedure as IProcedureOverview;
  ctrl.procedureName = procedure.name;
  ctrl.initialPublicType = procedure.publicType;
  ctrl.publicType = procedure.publicType;
  ctrl.publicShareableUrl = `${window.location.origin}/sop/${procedure.id}`;
  ctrl.iframeTag = `<iframe width="650" height="800" src="${ctrl.publicShareableUrl}" frameborder="0"></iframe>`;

  ctrl.save = () => {
    $scope.closeThisDialog({
      id: procedure.id,
      publicType: ctrl.publicType
    } as IProcedureSharingResult);
  };

  ctrl.cancel = () => {
    $scope.closeThisDialog();
  };

  ctrl.onPublicTypeChange = (value: PublicType | null) => {
    ctrl.publicType = value;
  };
}

export interface IProcedureSharingResult {
  id: Guid;
  publicType: PublicType | null;
}
